import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import type { GenerateAIRequest, GenerateAIResponse } from '@/types/generate-ai';

interface UseGeneratePurposeProps {
  tenantId: string;
}

export function useGeneratePurpose({ tenantId }: UseGeneratePurposeProps) {
  return useMutation<GenerateAIResponse, Error, GenerateAIRequest>({
    mutationFn: async (data: GenerateAIRequest) => {
      if (!tenantId) {
        throw new Error('Tenant ID is required');
      }

      try {
        const response = await axiosInstance.post<GenerateAIResponse>(
          `${env.apiTasklistBaseUrl}/api/v1/compro/${tenantId}/ai/generate-purpose`,
          data,
        );

        if (!response.data.success) {
          throw new Error(response.data.message || 'Failed to generate purpose');
        }

        return response.data;
      } catch (error) {
        // Handle axios error response (400, 500, etc)
        if (error && typeof error === 'object' && 'response' in error) {
          const axiosError = error as { response?: { data?: GenerateAIResponse } };
          const errorMessage = axiosError.response?.data?.message || 'Failed to generate purpose';
          throw new Error(errorMessage);
        }
        throw error;
      }
    },
  });
}
